<template>
  <div class="swiper">
    <div class="swiper-wrapper">
      <slot />
    </div>
    <slot name="button-next" />
    <slot name="button-prev" />
  </div>
</template>

<script>
import Swiper from 'swiper/bundle';

const globalDefaults = {
  centeredSlides: true,
  centeredSlidesBounds: true,
  direction: 'horizontal',
  freeMode: { enabled: true },
};

export default {
  name: 'AppSwiper',
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.$swiper = new Swiper(this.$el, { ...globalDefaults, ...this.options });
  },
  beforeDestroy() {
    if (this.$swiper) {
      this.$swiper.destroy(true, true);
      this.$swiper = null;
    }
  },
};
</script>
